import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';

import CurrencyConverter from '../../CurrencyConverter';

import messages from '../../../locale/jsonMessages';

import cs from '../../commonStyle.css';
import s from '../ViewMessage.css';

const SubTotal = (props) => {

    const { total, currency, userType } = props;

    return (
        <div className={cx(cs.dataTableGrid, cs.paymentDivider)}>
            <div className={cx(cs.textStart, userType === 'renter' && [cs.commonSmallText18, cs.fontWeightBold],
                userType === 'owner' && [cs.commonSmallText16])}>
                <FormattedMessage {...messages.subTotal} />
            </div>
            <div className={cx(cs.commonSmallText16, cs.textEnd)}>
                <CurrencyConverter amount={total} from={currency} />
            </div>
        </div>
    );
}

export default withStyles(cs, s)(SubTotal);

